export function isEven(n) {
  return n % 2 === 0;
}

export function clamp(v, lb, up) {
  return Math.min(Math.max(v, lb), up);
}
